module.exports = __webpack_public_path__ + "img/anduice-empty@2x.170d77f4.png";